import { CSSProperties, TableHTMLAttributes } from 'react';
import classNames from 'classnames';

import { isDefined } from '@/utils/is-defined';

import className from './layout-table-data.module.css';

interface TableDataProps extends TableHTMLAttributes<HTMLTableCellElement> {
  borderRadius?: CSSProperties['borderRadius'];
  padding?: CSSProperties['padding'];
  maxWidth?: CSSProperties['maxWidth'];
  borderBottom?: CSSProperties['borderBottom'];
}

const TableData = ({
  borderBottom,
  borderRadius,
  maxWidth,
  padding,
  children,
  style = {},
  ...props
}: TableDataProps) => {
  return (
    <td
      {...props}
      className={classNames(className['bl-table-data'], props.className)}
      style={
        {
          ...(isDefined(borderRadius) ? { '--table-data-border-radius': borderRadius } : {}),
          ...(isDefined(padding) ? { '--table-data-padding': padding } : {}),
          ...(isDefined(maxWidth) ? { '--table-data-max-width': maxWidth } : {}),
          ...(isDefined(borderBottom) ? { '--table-data-border-bottom': borderBottom } : {}),
          ...style,
        } as CSSProperties
      }
    >
      {children}
    </td>
  );
};

export default TableData;
